import { Injectable, inject, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

const AVAILABLE_LANGS = ['en'];
const DEFAULT_LANG = 'en';

@Injectable({ providedIn: 'root' })
export class LocaleService {
  private readonly transloco = inject(TranslocoService);

  readonly currentLocale = signal<string>(DEFAULT_LANG);

  setLocale(lang: string): void {
    this.transloco.setActiveLang(lang);
    this.currentLocale.set(lang);
    document.documentElement.lang = lang;
    // TODO: persist locale to Firestore user document
  }

  init(): void {
    const browser = navigator.language.split('-')[0].toLowerCase();
    const lang = AVAILABLE_LANGS.includes(browser) ? browser : DEFAULT_LANG;
    this.setLocale(lang);
    // TODO: read locale from Firestore user document and call setLocale() with it
  }
}
